export const AVAILABLE_EXTENSIONS = [
  'jpeg',
  'jpg',
  'png',
  'svg',
  'webp',
  'heic',
]
